export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_SIRE_fragment_7.61308314.jpg";